import { SendOutlined, TruckOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import { MenuProps } from 'antd/lib';
import Card from 'components/card';
import SITELINKS from 'constants/sitelinks';
import { useEffect, useState } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import LastMileRatesList from './components/lastMile';
import InterUrbanRatesList from './components/interUrban';

type MenuItem = Required<MenuProps>['items'][number];

const RatesList = () => {
  const location = useLocation();
  const history = useHistory();
  const [selected, setSelected] = useState(SITELINKS.rates.lastMile);

  useEffect(() => {
    if (location.pathname === SITELINKS.rates.interUrban) {
      setSelected(SITELINKS.rates.interUrban);
    }
  }, [location.pathname]);

  const items: MenuItem[] = [
    {
      label: 'Última milla',
      type: 'item',
      key: SITELINKS.rates.lastMile,
      icon: <SendOutlined />,
    },
    {
      label: 'Inter-urbano',
      type: 'item',
      key: SITELINKS.rates.interUrban,
      icon: <TruckOutlined />,
    },
  ];

  const handleSelection: MenuProps['onClick'] = (e) => {
    setSelected(e.key);
    history.push(e.key);
  };

  return (
    <>
      <Card
        bodyStyle={{ padding: '0', overflow: 'hidden', marginBottom: '16px' }}
      >
        <Menu
          items={items}
          onClick={handleSelection}
          selectedKeys={[selected]}
          mode="horizontal"
          style={{ width: '100%' }}
        />
      </Card>
      <Switch location={location}>
        <Route
          path={SITELINKS.rates.lastMile}
          render={() => <LastMileRatesList />}
        />
        <Route
          path={SITELINKS.rates.interUrban}
          render={() => <InterUrbanRatesList />}
        />
      </Switch>
    </>
  );
};

export default RatesList;
